// Cashier Transactions Vuex

import state from './cashierTransactionStates.js'
import * as getters from './cashierTransactionGetters.js'
import * as mutations from './cashierTransactionMutations.js'
import * as actions from './cashierTransactionActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
